export default {
  ThreeTimesDaily: 1,
  OnceDaily: 7,
  ShabbatAndHolidays: 8,
};
